import React from "react"
import { Grid } from "@mui/material"
import Pacchi from "../Pacchi"
import __t from "../../../lib/traduzioni"

const FrammentoPacchi = ({methods, classes, daShortcode}) => {
    return (
        <>
            <Grid item xs={12} p={1} className={classes.formGroupBox}>
                <Pacchi methods={methods} daShortcode={daShortcode} title={__t("misure")} />
            </Grid>
        </>
    )
}

export default FrammentoPacchi


